import type { ApiCallerT } from "shared/infrastructure/api/types";

import { leaveTypesMapper } from "./mappers/leaveTypes.mapper";
import { createLeaveTypesRepository } from "./repositories/leaveTypes.repository";
import { createLeaveTypesApi } from "./api/leaveTypes.api";

export const buildLeaveTypesRepository = ({ apiCaller }: { apiCaller: ApiCallerT }) => {
  const leaveTypesApi = createLeaveTypesApi(apiCaller);

  return createLeaveTypesRepository({ leaveTypesApi, leaveTypesMapper });
};
